export const TRACK_CONTEXT = {
  TABS: 'platform_dashboard_overview_tabs-interaction',
  PENDING: 'platform_dashboard_pending_cards-interaction',
  OVERVIEW_MINI_CARD: 'platform_dashboard_overview_minicard-interaction',
  OVERVIEW: 'platform_dashboard_overview_cards-interaction',
  PERFORMANCE_KPI_CARD: 'platform_dashboard_performance_minicard-interaction',
  PERFORMANCE_CARD: 'platform_dashboard_performance_cards-interaction',
  PERFORMANCE_TABLE: 'platform_dashboard_performance_tables-interaction',
};

export const TRACK_PENDING_CARD = {
  EVENTS_FOR_TODAY: 'Events for today',
  UNASSIGNED_INQUIRIES: 'Unassigned inquiries',
  CONTACTS_TO_REACH_OUT: 'Contacts to reach out',
  LISTINGS_PORTALS_AND_ERRORS: 'Listings portals and errors',
  LEADS_TO_EXPIRE: 'Leads to expire',
  RESERVATIONS_TO_EXPIRE: 'Reservations to expire',
  RENTS_TO_EXPIRE: 'Rents to expire',
  VISITS_TO_CONFIRM: 'Visits to confirm',
  PROPERTIES_PENDING_REVIEW: 'Properties pending review',
  DEVELOPMENTS_PENDING_REVIEW: 'Developments pending review',
  QPRECO_MARKETPLACE: 'QPreço Marketplace',
  MARKETPLACE_REGISTRATION_QUALITY: 'Marketplace registration quality',
};

export const TRACK_OVERVIEW_MINI_CARD = {
  CONTACTS: 'Contacts',
  PROPERTIES: 'Properties',
  DEVELOPMENTS: 'Developments',
};

export const TRACK_OVERVIEW_CARD = {
  CONTACT_SOURCE: 'Contact source',
  LEADS: 'Leads',
  PENDING_SCHEDULED_EVENTS: 'Pending scheduled events',
  VISITS: 'Visits',
  PROPERTY_TOTAL_VALUE: 'Property total value',
  PROPERTY_OPERATION: 'Property operation',
  PROPERTY_TYPE: 'Property type',
  PROPERTY_LOCATION: 'Property location',
  PROPERTY_CONSTRUCTION_AGE: 'Property construction age',
  PROPERTY_ENTRY_DATE: 'Property entry date',
  PROPERTY_LAST_UPDATE: 'Property last update',
  CONTACT_LAST_UPDATE: 'Contact last update',
  DEVELOPMENT_TYPE: 'Development type',
  DEVELOPMENT_LOCATION: 'Development location',
};

export const TRACK_PERFORMANCE_KPI_CARD = {
  INQUIRIES_RECEIVED: 'Inquiries received',
  NEW_CONTACTS: 'New contacts',
  RESPONSE_TIME: 'Response time',
  VISITS_MADE: 'Visits made',
  CONVERSION_RATE: 'Conversion rate',
  CONVERSION_TIME: 'Conversion time',
  ADDED_PROPERTIES: 'Added properties',
  CONCRETED_OPERATIONS: 'Concreted operations',
};

export const TRACK_PERFORMANCE_CARD = {
  INQUIRIES_RECEIVED: 'Inquiries received',
  NEW_CONTACTS: 'New contacts',
  MOST_INQUIRIES_PROPERTIES: 'Most inquiries properties',
  LEAST_INQUIRIES_PROPERTIES: 'Least inquiries properties',
  MOST_INQUIRIES_DEVELOPMENTS: 'Most inquiries developments',
  LEAST_INQUIRIES_DEVELOPMENTS: 'Least inquiries developments',
  MEDIAN_RESPONSE_TIME: 'Median response time',
  RESPONSE_TIME_EVOLUTION: 'Response time evolution',
  VISITS_MADE: 'Visits made',
  VISITS_MADE_EVOLUTION: 'Visits made evolution',
  EVENTS_MADE: 'Events made',
  RESERVATIONS_CREATED: 'Reservations created',
  CLOSED_LEADS: 'Closed leads',
  CONVERSION_RATE: 'Conversion rate',
  MEDIAN_CONVERSION_TIME: 'Median conversion time',
  PRODUCTION_RATE: 'Production rate',
  ADDED_PROPERTIES: 'Added properties',
  CONCRETED_OPERATIONS: 'Concreted operations',
  AGENTS_PERFORMANCE: 'Agents performance',
  CONCRETED_OPERATIONS_EVOLUTION: 'Concreted operations evolution',
  CONCRETED_OPERATIONS_SOURCE: 'Concreted operations source',
};

export const TRACK_PERFORMANCE_TABLE = {
  INQUIRIES_RECEIVED: 'Inquiries received',
  NEW_CONTACTS: 'New contacts',
  RESPONSE_TIME: 'Response time',
  DONE_VISITS: 'Done visits',
  DONE_EVENTS: 'Done events',
  CONVERSION_RATE: 'Conversion rate',
  CONVERSION_TIME: 'Conversion time',
  ADDED_PROPERTIES: 'Added properties',
  CONCRETED_OPERATIONS: 'Concreted operations',
  PROPERTY_CONSULTATIONS: 'Property consultations',
  DEVELOPMENT_CONSULTATIONS: 'Development consultations',
  CLOSED_LEADS: 'Closed leads',
  RESERVATIONS_CREATED: 'Reservations created',
  PRODUCTION_RATE: 'Production rate',
};

export const TRACK_ELEMENT = {
  ROW: 'Row',
  SHOW_ALL: 'Show all button',
  PROPERTY_ADDRESS: 'Property address',
  CONTACT_NAME: 'Contact name',
  AGENT_NAME: 'Agent name',
  PORTAL_NAME: 'Portal name',
  RADIO_BUTTON_OPTION: 'Radio button option',
  COLUMN_ORDER: 'Order',
  SEARCH_INPUT: 'Search input',
  DROPDOWN_SEARCH: 'Dropdown search',
  DROPDOWN_SEARCH_SELECTION: 'Dropdown search selection',
  DROPDOWN_SHOW_ALL: 'Dropdown show all',
  DOWNLOAD_BUTTON: 'Download button',
  BRANCH_GROUP_CHECKBOX: 'Group by branch',
};

export const TRACK_TAB = {
  PENDING: 'Tab pending',
  OVERVIEW: 'Tab overview',
  PERFORMANCE: 'Tab performance',
};
